// import { message } from "antd";
// import { getTeamInformation } from "./team.actions";
// import axios from "axios";

import { TrainingAPI } from "../../api/TrainingAPI";

export const AUTH_SET_LOGIN_STATUS = "[AUTH]_SET_LOGIN_STATUS";
export const AUTH_SET_LOADING = "[AUTH]_SET_LOADING";
export const AUTH_SET_CURRENT_USER_DATA = "[AUTH]_SET_CURRENT_USER_DATA";

export const setAuthLoginStatus = (data) => {
  return {
    type: AUTH_SET_LOGIN_STATUS,
    data,
  };
};
export const setAuthLoading = (data) => {
  return {
    type: AUTH_SET_LOADING,
    data,
  };
};

export const setAuthCurrentUser = (data) => ({
  type: AUTH_SET_CURRENT_USER_DATA,
  data,
})

const trainingAPI = new TrainingAPI();

// const authAPI = new Auth();

// export const loginWithToken = () => {
//   return async (dispatch) => {
//     dispatch(setAuthLoading(true));
//     try {
//       // // const loggedIn = await authAPI.logged_in();
//       // dispatch(setAuthLoginStatus(!!loggedIn));
//       // axios.defaults.headers.common[
//       //   "Authorization"
//       // ] = `JWT ${localStorage.getItem("token")}`;
//       // dispatch(getTeamInformation());
//     } catch (e) {
//       dispatch(setAuthLoginStatus(false));
//       console.error(e);
//     }
//     dispatch(setAuthLoading(false));
//   };
// };

// export const loginWithEmailAndPassword = (email, password, navigate) => {
//   return async (dispatch) => {
//     dispatch(setAuthLoading(true));
//     try {
//       // const data = await authAPI.login(email, password);
//       // await dispatch(setAuthLoginStatus(true));
//       // axios.defaults.headers.common["Authorization"] = `JWT ${data.token}`;
//       // localStorage.setItem("token", data.token);
//       // localStorage.setItem("email", email);
//       // message.success("Logged In Successfully");
//       // const team = await authAPI.teamInfo(data.token);
//       // localStorage.setItem("metric", team.metric);
//       // localStorage.setItem("team_logo", team.team_logo);
//       // dispatch(getTeamInformation());
//       // navigate("/overview");
//     } catch (e) {
//       dispatch(setAuthLoginStatus(false));
//       console.error(e);
//     }
//     dispatch(setAuthLoading(false));
//   };
// };

// export const logout = () => {
//   return async (dispatch) => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("email");
//     dispatch(setAuthLoginStatus(false));
//   };
// };

export const getCurrentUserData = () => {
  return async dispatch => {
    try {
      const data = await trainingAPI.getCurrentUserData();
      dispatch(setAuthCurrentUser(data));
    } catch(e) {
      console.error(e);
    }
  }
}
